import { Type } from 'class-transformer'
import { RouteDirection } from '../../../constants/RouteDirection'
import { Room } from '../Room'

export class Route {

  @Type(() => Room)
  public readonly room: Room

  public readonly distance: string

  public readonly direction: RouteDirection|string

  constructor(room: Room, distance: string, direction: RouteDirection|string) {
    this.room = room
    this.distance = distance
    this.direction = direction
  }
}
